import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function RedefinirSenha() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) { toast.error("As senhas não coincidem."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Senha redefinida! Faça login.");
      navigate("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Link inválido ou expirado.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bg p-6">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl border border-slate-100 p-8 sm:p-10">
        <Logo />
        <h1 className="mt-8 font-heading text-2xl font-black text-brand-ink">Nova senha</h1>
        <p className="mt-2 text-brand-muted text-sm">Escolha uma nova senha para sua conta.</p>
        {!token ? (
          <p className="mt-6 text-red-500 text-sm">Link inválido. Solicite um novo em "Esqueci minha senha".</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="pw">Nova senha</Label>
              <Input id="pw" type="password" required value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5 rounded-xl h-11" data-testid="reset-password" />
            </div>
            <div>
              <Label htmlFor="c">Confirmar senha</Label>
              <Input id="c" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5 rounded-xl h-11" data-testid="reset-confirm" />
            </div>
            <Button type="submit" disabled={loading} className="w-full rounded-full h-12 bg-brand-blue hover:bg-blue-700 font-semibold" data-testid="reset-submit">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Redefinir senha"}
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-6 block text-center text-sm text-brand-muted hover:text-brand-ink">Voltar ao login</Link>
      </div>
    </div>
  );
}
